import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var HeadSideCough = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M616 304a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm-64 112a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-64-56a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm128 104a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm0-104a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-64-40a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13 208.13 0 0 0 234.1 0H192C86 0 0 86 0 192c0 56.75 24.75 107.62 64 142.88V512h224v-32h64a64 64 0 0 0 64-64h-96a32 32 0 0 1 0-64h96v-32h32a32 32 0 0 0 29.22-45zM288 224a32 32 0 1 1 32-32 32.07 32.07 0 0 1-32 32z"
  }));
});
HeadSideCough.displayName = 'HeadSideCough';
export var HeadSideCoughDimensions = {
  height: 512,
  width: 640
};